<template>
  <success-page-layout
    class="bg-transparent"
    hide-continue-browser
    web-to-mobile-flag="mupInviteAccepted"
    store-badges-button-code="body-20210304-success-page-join-organisation"
    :promote-app-download="!hasMobileApp || isDesktop"
  >
    <template v-slot:content>
      <b-headline type="h1" typography="h2" class="mb-6">
        {{ headline }}
      </b-headline>
      <p v-html="copy" />
    </template>

    <template v-slot:infobox v-if="cancelNoteType && cancelNoteTypes.includes(cancelNoteType)">
      <cancel-instructions :cancel-note-type="cancelNoteType" new-subscription-type="mup" />
    </template>

    <template v-slot:image>
      <joined-connect-image />
    </template>
  </success-page-layout>
</template>

<script>
import { mapGetters } from "vuex"
import { getSearchParam } from "@/utils/location"
import BHeadline from "@/component-library/b-headline"
import SuccessPageLayout from "@/pages/success-page/components/success-page-layout"
import CancelInstructions from "@/pages/success-page/components/shared/cancel-instructions"
import JoinedConnectImage from "@/pages/success-page/components/joined-connect/image"
import platform from "@/modules/visitor-platform"
import sanitizeHtml from "sanitize-html"
// eslint-disable-next-line no-undef
const confetti = require("canvas-confetti")

export default {
  name: "JoinOrganisationSuccess",
  components: {
    BHeadline,
    SuccessPageLayout,
    JoinedConnectImage,
    CancelInstructions
  },
  data() {
    return {
      cancelNoteTypes: ["itunes", "recurly", "stripe"]
    }
  },
  computed: {
    ...mapGetters(["hasMobileApp"]),
    cancelNoteType() {
      return getSearchParam("cancelNote")
    },
    inviterName() {
      return getSearchParam("inviterName") || "Your friend"
    },
    sanitizedInviterName() {
      return sanitizeHtml(this.inviterName, { allowedTags: [], allowedAttributes: {} })
    },
    headline() {
      return this.$t("headline", { inviterName: this.sanitizedInviterName })
    },
    copy() {
      return this.$t("copy", { inviterName: this.sanitizedInviterName })
    },
    isDesktop() {
      return platform.isDesktop()
    }
  },
  mounted() {
    this.showConfetti()
  },
  methods: {
    showConfetti() {
      const confettiCanvas = document.createElement("canvas")
      confettiCanvas.style.cssText = "position: absolute; z-index: 1000000; left: 0; width: 100%; height: 100vh"
      document.body.appendChild(confettiCanvas)
      const myConfetti = confetti.create(confettiCanvas, {
        resize: true,
        useWorker: true
      })
      myConfetti({
        particleCount: 250,
        spread: 150
      })
      setTimeout(() => {
        myConfetti.reset()
        confettiCanvas.remove()
      }, 4000)
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Great! You and {inviterName} are now sharing Blinkist Premium.",
        copy: "Your account is linked to {inviterName}'s subscription and will be active for the same time period."
      },
      de: {
        headline: "Super! Du und {inviterName} teilt jetzt Blinkist Premium.",
        copy: "Dein Konto ist mit dem Abo von {inviterName} verknüpft und so lange aktiv, wie das Abo läuft."
      }
    }
  }
}
</script>
